import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  output,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-switch',
  styleUrl: './switch.scss',
  templateUrl: './switch.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
})
export class SwitchComponent implements ControlValueAccessor {
  /** Libellé affiché à côté du commutateur. */
  @Input() label = '';

  /** Texte d'aide affiché sous le libellé. */
  @Input() hint = '';

  /** Désactive le commutateur. */
  @Input() disabled = false;

  /** Identifiant HTML (lié au libellé). */
  @Input() id = '';

  /** Émis à chaque bascule (usage hors formulaire). */
  readonly changed = output<boolean>();

  @Input()
  set value(value: unknown) {
    this.writeValue(value);
  }

  protected checked = false;

  private onChange: (value: boolean) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  writeValue(value: unknown): void {
    this.checked = value === true;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  protected toggle(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.checked = target.checked;
    this.onChange(this.checked);
    this.onTouched();
    this.changed.emit(this.checked);
  }
}
